<script>
import Utils from "@/services/utils.js";

export default {
  name: "UiRelativeDate",
  components: {
  },
  props: {
    date: {
      type: String,
      required: true,
    },
  },
  computed: {
    relativeDate() {
      return Utils.momentLocalised(this.date).fromNow()
    },
    exactDate() {
      return Utils.momentLocalised(this.date).format('lll')
    },
  },
}
</script>
<template>
  <time 
    :title="exactDate"
    :datetime="date"
    data-component="UiRelativeDate"
  >
    {{ relativeDate }}
  </time>
</template>
<style lang="scss" scoped>
[data-component="UiRelativeDate"] {
  text-decoration: underline dotted; 
  cursor: help;
}
</style>